import React, {
  useRef, useEffect, useState, useContext
} from 'react';

import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import mapgl from 'maplibre-gl';
import './Map.css';
import { MapContext, MapContextProvider } from '../MapContext';
import { LayerProvider } from '../LayerContext';
import NavBar from '../NavBar/NavBar';
import { drawStyles } from './drawStyles';
import ScaleControl from './ScaleControl';
import SideBar from '../SideBar/SideBar';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'


import MapboxDraw from "@mapbox/mapbox-gl-draw";
import 'maplibre-gl/dist/maplibre-gl.css';

const Map = () => {

  const mapContainer = useRef(null);
  const map = useRef(null);
  const draw = useRef(null);
  const { setMap, setDraw } = useContext(MapContext);
  const [layerProps, setLayerProps] = useState([]);

  const theme = createTheme({
    palette: {
      secondary: {
        main: '#AAA'
      },
      primary: {
        main: '#DDD'
      },
      mode: 'dark',
    }
  });
  const viewState = {
    "lng": 0.892,
    "lat": 0.025,
    "zoom": 14.5
  };

  useEffect(() => {
    if (map.current) {
      return;
    }
    map.current = new mapgl.Map({
      container: mapContainer.current,
      style: {
        version: 8,
        sources: {},
        layers: [
          {
            id: 'background',
            type: 'background',
            paint: { 'background-color': 'black' }
          }
        ]
      },
      center: [viewState.lng, viewState.lat],
      zoom: viewState.zoom
    });

    map.current.on('load', () => {
      // required for mapbox - maplibre compatibility
      MapboxDraw.constants.classes.CONTROL_BASE = "maplibregl-ctrl";
      MapboxDraw.constants.classes.CONTROL_PREFIX = "maplibregl-ctrl-";
      MapboxDraw.constants.classes.CONTROL_GROUP = "maplibregl-ctrl-group";

      draw.current = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true,
        },
        styles: drawStyles
      });

      map.current.addControl(new mapgl.NavigationControl(), 'top-left');
      map.current.addControl(draw.current, 'top-left');
      map.current.addControl(new ScaleControl({
        maxWidth: 180,
        unit: 'um'
      }), 'bottom-right');

      map.current.on('draw.modechange', function (e) {
        if (e.mode == 'draw_polygon') {
          map.current.getCanvas().style.cursor = 'crosshair';
        } else if (e.mode == 'simple_select') {
          map.current.getCanvas().style.cursor = 'grab';
        }
      });

      setMap(map);
      setDraw(draw);
    });
  }, [setMap, setDraw]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <LayerProvider>
          <CssBaseline />
          <NavBar layerProps={layerProps} />
          <div className="under-navbar">
            <SideBar layerProps={layerProps} setLayerProps={setLayerProps} />
            <div className="map-div">
              <div ref={mapContainer} className="map-container" />
            </div>
          </div>
        </LayerProvider>
      </ThemeProvider>
    </>
  )
}

export default Map;
